import React, { useState, useEffect } from 'react'
import PageLoader from 'components/PageLoader';
import BalloonPopUp from 'components/BalloonPopUp/BalloonPopUp';
import 'react-dates/lib/css/_datepicker.css';
import {SingleDatePicker} from 'react-dates';
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css';
import moment from 'moment';
import './CalendarView.scss';

const CalendarView = (props) => {
  const [hourDropdownIsOpen, setHourDropdownIsOpen] = useState(false);
  const [dateSelectorOpen, setDateSelectorOpen] = useState(true)

  useEffect(() => {
    if (props.date) {
      setDateSelectorOpen(false)
      setHourDropdownIsOpen(true)
    } else {
      setDateSelectorOpen(true) 
      setHourDropdownIsOpen(false)
    }
  }, [props.date])


  useEffect(() => {
    if(props.hour){
      setHourDropdownIsOpen(false)
    }
  }, [props.hour])

  return (
    <PageLoader loading={props.isLoadingDates} style={{height: '50px'}}>
      {!props.isLoadingDates && 
        <div className="column-picker">
          {/*DIAS*/}
          {props.date && !dateSelectorOpen ? 
          <>
          <div className="Grid-cell date-picker">
            <div className="title"> DATA </div>
            <div className="date-input" onClick={() => {
              setDateSelectorOpen(true) 
              setHourDropdownIsOpen(false)
              props.handleSetHour("")
            }}>
              <i className="fa fa-calendar"></i>
              <h4>{moment(props.date).format('DD/MM/YY')}</h4>
            </div>
          </div>
          {props.hasAvailableDates &&
            <div className="Grid-cell hours">
              <div className="title"> HORA</div>
              <BalloonPopUp
                disabled={props.isVoucherSelected}
                disabledClick={props.isDateDisabled(props.date)}
                onClose={() => setHourDropdownIsOpen(false)}
                items={props.date ? props.availableHours.sort((a,b) => a.start < b.start ? -1 : 1).map(o => ({
                  name: o.start,
                  value: o.start,
                  pk_schedule_rule: o.pk_schedule_rule
                })) : []}
                onClick={() => setHourDropdownIsOpen(!hourDropdownIsOpen)}
                onClickItem={e => props.handleSetHour(e)}
                open={hourDropdownIsOpen}
                selectedValue={(props.hour) ? props.hour.start : ""}/>
            </div>
            }
            </>
          :
          <div className="header-title-date calendar-picker">
              <p>Selecione a Data</p>
              <Calendar 
                locale='pt-BR' 
                value={props.date}
                minDetail="month"
                defaultActiveStartDate={props.calendarToOpenDate}
                onChange={(date) => {
                  props.handleSetDate(date)
                }}
                tileDisabled={({ date }) => props.isDateDisabled(date)}
                next2Label={null}
                prev2Label={null}
              />
            </div>
          }
        </div>
      }
    </PageLoader>
  )
}
export default CalendarView
